import React from 'react';
import HeaderContainer from 'containers/header';
import ErrorContainerStaff from 'containers/error/staff';
import FooterContainer from 'containers/footer';

const ErrorPageStaff = () => {
  return (
    <>
      <HeaderContainer />
      <ErrorContainerStaff />
      <FooterContainer />
    </>
  );
};

export default ErrorPageStaff;
